import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";

export interface SalesContext {
  iPlaceIds: string[];
  dateStartMillis: number;
  dateEndMillis: number;
  tz: string;
}

@Injectable()
export class PetrolSalesService {
  private errorHandler(error: any): Promise<any> {
    console.log("An error occurred", error);
    return Promise.reject(error.message || error);
  }

  private basePath = "/iPlaceCloud/api/v1/";

  constructor(private httpClient: HttpClient) { }

  getSales(salesContext: SalesContext): Promise<any> {
    let url = this.basePath + "sales";
    const params = new HttpParams()
      .set('iPlaceIds', salesContext.iPlaceIds.join(', '))
      .set('dateStartMillis', salesContext.dateStartMillis.toString())
      .set('dateEndMillis', salesContext.dateEndMillis.toString())
      .set('tz', salesContext.tz);
    return this.httpClient
      .get(url, { params })
      .toPromise()
      .then(res => res as any[])
      .catch(error => this.errorHandler(error));
  }

}
